export function isMediaVideo(media) {
    return media.videoId !== undefined && media.videoId !== null;
}
